import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReportQtyMismatchPageRoutingModule } from './report-qty-mismatch-routing.module';

import { ReportQtyMismatchPage } from './report-qty-mismatch.page';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportQtyMismatchPageRoutingModule,
    NgxDatatableModule
  ],
  declarations: [ReportQtyMismatchPage]
})
export class ReportQtyMismatchPageModule {}
